'use strict';/* global define, console */define('modules/integrations/constants/imported-items-types',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Config for the expected stats types of imported items
   *
   *
   * NOTE: `failed` status is verified on a different base which
   * is not suitable with this config!
   *
   * `item.unsolvalbeIssues.length > 0 || item.solvalbeIssues.length > 0`
   */module.exports={imported:{resultName:'success',possibleActions:['import']},ignored:{resultName:'not_executed',possibleActions:['confirm','import','activate','deactivate','set_supervisor']},modified:{resultName:'success',possibleActions:['confirm','activate','deactivate','set_supervisor']}};});
